var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn _fw-500",on:{"click":_vm.goBack}},[_c('ArrowLeft',{staticClass:"_mr-2"}),_c('span',[_vm._v(_vm._s(_vm.$t('interface.back')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }